
function Parametri(parametro) {
    switch (parametro) {
        case 'serverURL': return 'https://massbroken.dyndns.org:2003/ema/link_back_front_sito.php'; break;
        case 'release': return "S-A";
    }
    return "";
}

export default Parametri;